export default function DOM_Comment() {
  return (
    <div>
      <h1>DOM_Comment</h1>
      <p>This is the DOM_Comment component.</p>
    </div>
  );
}